import Scenario3Part1 from './Scenario3Part1';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { CalmBaseScenario } from '../CalmBaseScenario';
import Scenario3Part2 from './Scenario3Part2';
import Scenario3Part3 from './Scenario3Part3';
import Scenario3Part4 from './Scenario3Part4';
import Scenario3Part5 from './Scenario3Part5';
import Scenario3Part6 from './Scenario3Part6';

export default class Scenario3 extends CalmBaseScenario {
	parts: BaseScenarioPart<CalmBaseScenario>[] = [
		new Scenario3Part1(this, () => {this.goToPart2()}),
		new Scenario3Part2(this, () => {this.goToPart3()}),
		new Scenario3Part3(this, () => {this.goToPart4()}),
		new Scenario3Part4(this, () => {this.goToPart5()}),
		new Scenario3Part5(this, () => {this.goToPart6()}),		
		new Scenario3Part6(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public getEnvironmentProps(): VideoEnvironmentProps {
		return {
			controls: false,
			autoBlur: true
		};
	}

	public get currentLevel(): number {
		return 2;
    }
	
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<CalmBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario3/' + fileName + '.mp3';
	}

	start() {
        this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		this.goToPart1();
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario3.parts.level3Part1.id, () => {
			this.destroyAllUIInstances();
		});
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario3.parts.level3Part2.id);
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario3.parts.level3Part3.id);
	}

	goToPart4() {
		this.loadPart(constants.scenarios.scenario3.parts.level3Part4.id);
	}

	goToPart5() {
		this.loadPart(constants.scenarios.scenario3.parts.level3Part5.id);
	}

	goToPart6() {
		this.loadPart(constants.scenarios.scenario3.parts.level3Part6.id);
	}

	goToScenarioEnd() {
	}
}